import RouteUrl from '^enums/routing/RouteUrl';
import sharedHistory from '^sharedHistory';

export const getErrorRouteUrl = (): string => RouteUrl.Error;

export const goToErrorRoute = (url: string = getErrorRouteUrl()): void => {
  sharedHistory.push(url);
};

export const getRootPageRoutePath = (): string => (
  `${RouteUrl.Root}`
);

